// National flags for the language menu. Their colours are the flags' own, fixed in every look and
// colour scheme, so this file is exempt from FE-013.R6 (no hex literals) in eslint.config.js.
import React from 'react'

import type { TLocale } from '#lib/i18n'

const NLFlagCircle = (): React.JSX.Element => (
  <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
    <clipPath id="nl-clip">
      <circle cx="11" cy="11" r="11" />
    </clipPath>
    <g clipPath="url(#nl-clip)">
      <rect width="22" height="7.33" fill="#AE1C28" />
      <rect y="7.33" width="22" height="7.34" fill="#fff" />
      <rect y="14.67" width="22" height="7.33" fill="#21468B" />
    </g>
  </svg>
)

const UKFlagCircle = (): React.JSX.Element => (
  <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
    <clipPath id="uk-clip">
      <circle cx="11" cy="11" r="11" />
    </clipPath>
    <g clipPath="url(#uk-clip)">
      <rect width="22" height="22" fill="#012169" />
      <path d="M0 0L22 22M22 0L0 22" stroke="#fff" strokeWidth="3.6" />
      <path d="M0 0L22 22M22 0L0 22" stroke="#C8102E" strokeWidth="2" />
      <path d="M11 0V22M0 11H22" stroke="#fff" strokeWidth="6" />
      <path d="M11 0V22M0 11H22" stroke="#C8102E" strokeWidth="3.6" />
    </g>
  </svg>
)

const DEFlagCircle = (): React.JSX.Element => (
  <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
    <clipPath id="de-clip">
      <circle cx="11" cy="11" r="11" />
    </clipPath>
    <g clipPath="url(#de-clip)">
      <rect width="22" height="7.33" fill="#000" />
      <rect y="7.33" width="22" height="7.34" fill="#DD0000" />
      <rect y="14.67" width="22" height="7.33" fill="#FFCC00" />
    </g>
  </svg>
)

const FRFlagCircle = (): React.JSX.Element => (
  <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
    <clipPath id="fr-clip">
      <circle cx="11" cy="11" r="11" />
    </clipPath>
    <g clipPath="url(#fr-clip)">
      <rect width="7.33" height="22" fill="#002395" />
      <rect x="7.33" width="7.34" height="22" fill="#fff" />
      <rect x="14.67" width="7.33" height="22" fill="#ED2939" />
    </g>
  </svg>
)

const SAFlagCircle = (): React.JSX.Element => (
  <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
    <clipPath id="sa-clip">
      <circle cx="11" cy="11" r="11" />
    </clipPath>
    <g clipPath="url(#sa-clip)">
      <rect width="22" height="22" fill="#006C35" />
      <text x="11" y="12.5" textAnchor="middle" fill="#fff" fontSize="7" fontFamily="serif" fontWeight="bold">
        عربي
      </text>
    </g>
  </svg>
)

export const FLAG_ICONS: Record<TLocale, () => React.JSX.Element> = {
  en: UKFlagCircle,
  nl: NLFlagCircle,
  de: DEFlagCircle,
  fr: FRFlagCircle,
  ar: SAFlagCircle,
}
